import { useQuery } from '@apollo/client/react'
import {
  PortalMyOrganizationDocument,
  type PortalMyOrganizationQuery,
} from '@/graphql/generated/graphql'

export type MyOrganization = PortalMyOrganizationQuery['portalMyOrganization']

/**
 * Devuelve la organización del usuario autenticado. El gateway resuelve `me`
 * implícitamente y nos retorna `items[0]`; si el usuario aún no creó org
 * (Lead recién registrado), `organization` queda `null`.
 */
export function useMyOrganization() {
  const { data, loading, error, refetch } = useQuery(PortalMyOrganizationDocument, {
    fetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
  })

  const organization = data?.portalMyOrganization ?? null

  return {
    organization,
    loading,
    error,
    refetch,
  }
}
